import type { ChatMessage } from '@/types/chat';
import { getLatestAssistantMessage } from './getLatestAssistantMessage';

export const getLatestAssistantProcessingSteps = (messages: ChatMessage[]) =>
  getLatestAssistantMessage(messages)?.processingSteps ?? [];
